class RequestFailedError extends Error {
  constructor(response) {
    super('Request failed');

    this.name = 'RequestFailedError';
    this.response = response;
    this.status = response.status;
    this.httpCode = response.httpCode;
    this.message = response.statusText;

    Object.setPrototypeOf(this, RequestFailedError.prototype);
  }
}

export default RequestFailedError;
